import { BaseModel } from '~/models/baseModel';

export class BitlyModel extends BaseModel {
    public global_hash:string;
    public hash:string;
    public long_url:string;
    public new_hash:string;
    public url:string;
}
